import { multiselectMixin, pointerMixin } from 'vue-multiselect';
import userAgentMixin from '@/mixins/userAgent';

export default {
  name: 'multiselect',
  mixins: [
    multiselectMixin,
    pointerMixin,
    userAgentMixin,
  ],
  props: {
    name: {
      type: String,
      default: '',
    },
    selectLabel: {
      type: String,
      default: 'Press enter to select',
    },
    selectedLabel: {
      type: String,
      default: 'Selected',
    },
    deselectLabel: {
      type: String,
      default: 'Press enter to remove',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 99999,
    },
    maxHeight: {
      type: Number,
      default: 300,
    },
    limitText: {
      type: Function,
      default: count => `and ${count} more`,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    openDirection: {
      type: String,
      default: '',
    },
    showNoResults: {
      type: Boolean,
      default: true,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    adjust: {
      type: Boolean,
      default: true,
    },
    autofillAssist: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateSearch(query) {
      this.search = query;
      if (!this.autofillAssist || !query) return;
      const normalizedQuery = query.toString().trim().toLowerCase();
      const match = this.filteredOptions.find(option => !option.$isLabel && !option.$isDisabled &&
        this.getOptionLabel(option).toString().trim().toLowerCase() === normalizedQuery);
      if (match) {
        this.select(match);
      }
    },
    activate() {
      if (this.isOpen || this.disabled) return;
      if (this.adjust) {
        this.adjustPosition();
      }
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(() => {
          if (this.isOpen) this.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
    },
    addPointerElement({ key } = 'Enter') {
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerSet(index, option) {
      this.pointer = index;
      this.pointerDirty = true;
      if (this.isIos) {
        this.select(option);
      }
    },
  },
  computed: {
    visibleValue() {
      return this.multiple
        ? this.internalValue.slice(0, this.limit)
        : [];
    },
    deselectLabelText() {
      return this.showLabels
        ? this.deselectLabel
        : '';
    },
    selectLabelText() {
      return this.showLabels
        ? this.selectLabel
        : '';
    },
    selectedLabelText() {
      return this.showLabels
        ? this.selectedLabel
        : '';
    },
    inputStyle() {
      if (this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { width: 'auto' } : { width: '0', position: 'absolute' };
      }
      return {};
    },
    contentStyle() {
      return this.options.length
        ? { display: 'inline-block' }
        : { display: 'block' };
    },
    isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true;
      } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
        return false;
      }
      return this.prefferedOpenDirection === 'above';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/select/multiselect.js